/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BillingCoupon
 */
export interface BillingCoupon {
    /**
     * 
     * @type {string}
     * @memberof BillingCoupon
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof BillingCoupon
     */
    percentageOff: number | null;
    /**
     * 
     * @type {number}
     * @memberof BillingCoupon
     */
    amountOff: number | null;
    /**
     * 
     * @type {string}
     * @memberof BillingCoupon
     */
    duration: BillingCouponDurationEnum;
    /**
     * 
     * @type {number}
     * @memberof BillingCoupon
     */
    durationInMonths: number | null;
}

/**
* @export
* @enum {string}
*/
export enum BillingCouponDurationEnum {
    Once = 'Once',
    Repeating = 'Repeating',
    Infinite = 'Infinite'
}


/**
 * Check if a given object implements the BillingCoupon interface.
 */
export function instanceOfBillingCoupon(value: object): value is BillingCoupon {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('percentageOff' in value) || value['percentageOff'] === undefined) return false;
    if (!('amountOff' in value) || value['amountOff'] === undefined) return false;
    if (!('duration' in value) || value['duration'] === undefined) return false;
    if (!('durationInMonths' in value) || value['durationInMonths'] === undefined) return false;
    return true;
}

export function BillingCouponFromJSON(json: any): BillingCoupon {
    return BillingCouponFromJSONTyped(json, false);
}

export function BillingCouponFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingCoupon {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'percentageOff': json['percentageOff'],
        'amountOff': json['amountOff'],
        'duration': json['duration'],
        'durationInMonths': json['durationInMonths'],
    };
}

  export function BillingCouponToJSON(json: any): BillingCoupon {
      return BillingCouponToJSONTyped(json, false);
  }

  export function BillingCouponToJSONTyped(value?: BillingCoupon | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'percentageOff': value['percentageOff'],
        'amountOff': value['amountOff'],
        'duration': value['duration'],
        'durationInMonths': value['durationInMonths'],
    };
}

